import { render, staticRenderFns } from "./wxUnbind.vue?vue&type=template&id=77d2eece"
import script from "./wxUnbind.vue?vue&type=script&lang=js"
export * from "./wxUnbind.vue?vue&type=script&lang=js"
import style0 from "./wxUnbind.vue?vue&type=style&index=0&id=77d2eece&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports